
import { Vue, Component, Prop, PropSync } from 'nuxt-property-decorator'
import { AnalyticsOffersList } from '@alao-frontend/analytics.plugin'
import { OfferCategoryType } from '@alao-frontend/core'
import ComparatorLayout from '~/views/comparator/ComparatorLayout.vue'
import ComparatorSortBy from '~/components/comparator/amp/ComparatorSortBy.vue'
import ComparatorOfferList from '~/components/comparator/amp/ComparatorOfferList.vue'
import ComparatorFilter from '~/components/comparator/amp/ComparatorFilter.vue'
import OfferTypeSwitcher from '~/components/filters/OfferTypeSwitcher.vue'
import ComparatorMobileFilterPanel from '~/components/comparator/filters/ComparatorMobileFilterPanel.vue'
import FilterButton from '~/components/comparator/filters/FilterButton.vue'
import IconSortBy from '~/components/icons/IconSortBy.vue'
import IconFilter from '~/components/icons/IconFilter.vue'

const OfferModal = () => ({
  component: import(/* webpackChunkName: "comparator-components" */ '~/components/filters/OfferModal.vue'),
  delay: 1000,
  timeout: 3000,
})

@Component({
  components: {
    ComparatorLayout,
    OfferModal,
    ComparatorSortBy,
    ComparatorOfferList,
    ComparatorFilter,
    OfferTypeSwitcher,
    ComparatorMobileFilterPanel,
    FilterButton,
    IconSortBy,
    IconFilter,
  },
})
export default class ProviderComparator extends Vue {
  @PropSync('offerType', { required: false, default: OfferCategoryType.MOBILE_ABO_OFFER, type: String })
  protected selectedOfferType!: OfferCategoryType

  @Prop({ required: false, default: 10, type: Number })
  protected readonly resultsPerPage!: number

  @Prop({ required: false, default: 'default', type: String })
  protected readonly layout!: string

  @Prop({
    required: false,
    type: String,
  })
  readonly selectedProviderSlug!: string

  get layoutClassName () {
    return `comparator__main--${this.layout}`
  }

  listPosition = AnalyticsOffersList.CATALOG
  isFilterCollapsed = true
}
